module.exports = __webpack_public_path__ + "img/ads-manager-color.373014c7.svg";